<template>
  <div class="equip_list">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <ul v-if="list.length > 0">
      <li v-for="item in list" :key="item.id" @click="toDetail(item.id)">
        <el-image class="image" :src="item.logo" fit="cover">
          <div slot="error" class="image_error">暂无图片</div>
        </el-image>
        <div class="equip_list_info">
          <h3>{{ item.title }}</h3>
          <p><img src="@/assets/clock-icon.png" /><span>发布日期 {{ item.createdAt | dateFormat }}</span></p>
          <span class="pointer">查看</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'equipList',
  components: {},
  props: ['list'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
    toDetail (itemId) {
      this.$router.push({
        path: '/equip/detail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .equip_list { height: 100%; }
  .equip_list ul li { width: 225px; height: 362px; box-shadow: 0px 2px 12px 0px rgba(217, 222, 228, 1); border-radius: 2px; border: 1px solid #DCDFE6; transition: all 0.6s; float: left; margin-right: 20px; }
  .equip_list ul li:nth-child(4), .equip_list ul li:nth-child(8) { margin-right: 0; }
  .equip_list ul li:nth-child(-n+4) { margin-bottom: 20px; }
  .equip_list ul li:hover { transform: scale(1.08); }
  .equip_list ul li .image { width: 223px; height: 223px; border-radius: 2px; }
  .equip_list ul li .equip_list_info { height: 137px; padding: 15px; position: relative; }
  .equip_list ul li .equip_list_info p { margin-bottom: 10px; }
  .equip_list ul li .equip_list_info h3 { color: #666666; font-size: 16px; font-weight: 600; line-height: 20px; margin-bottom: 10px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .equip_list ul li .equip_list_info p img { margin-right: 6px; width: 14px; height: 14px; }
  .equip_list ul li .equip_list_info p span { font-size: 12px; color: #999999; line-height: 12px; }
  .equip_list ul li .equip_list_info > span { display: block; width: 70px; height: 32px; line-height: 32px; background: #CDEAAE; text-align: center; border-radius: 3px; font-size: 14px; color: #98B776; position: absolute; right: 15px; bottom: 15px; }
  .equip_list ul li .equip_list_info > span:hover { background: #76BF28; color: #FFFFFF; }
</style>



// WEBPACK FOOTER //
// src/components/equip/list.vue